(function() {
  var componentName = 'hero-banner';

  if (customElements.get(componentName)) {
    return;
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  customElements.define(componentName, class HeroBanner extends HTMLElement {
    constructor() {
      super();

      this.sliderEl = this.querySelector('.js-hero-banner-slider');
      this.paginationEl = this.querySelector('.js-slider-pagination');
      this.swiper = null;
      this.swiperWaitTimer = null;
      this.sliderMode = null;
      this.liteSlider = false;
      this.wrapperEl = null;
      this.slideEls = [];
      this.currentIndex = 0;
      this.handlePrevClick = null;
      this.handleNextClick = null;
      this.handlePaginationClick = null;
      this.handleTouchStart = null;
      this.handleTouchMove = null;
      this.handleTouchEnd = null;
      this.handleResize = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this.videoItems = [];
      this.videoTrack = null;
      this.videoSwiper = null;
      this.videoPlacement = null;
      this.selectedVideoBlock = null;
    }

    connectedCallback() {
      this.sliderEl = this.sliderEl || this.querySelector('.js-hero-banner-slider');
      this.paginationEl = this.paginationEl || this.querySelector('.js-slider-pagination');
      this.handleResize = this.onResize.bind(this);
      window.addEventListener('resize', this.handleResize);
      this.handleSliderScriptLoad = function(event) {
        if (event.target.tagName === 'SCRIPT' && window.Swiper && !this.swiper) {
          this.initSwiperWhenReady();
        }
      }.bind(this);
      document.addEventListener('load', this.handleSliderScriptLoad, true);
      this.handleBlockSelect = this.onBlockSelect.bind(this);
      this.handleBlockDeselect = this.onBlockDeselect.bind(this);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.initSwiperWhenReady();
    }

    disconnectedCallback() {
      document.removeEventListener('load', this.handleSliderScriptLoad, true);
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }

      if (this.swiperWaitTimer) {
        window.clearTimeout(this.swiperWaitTimer);
      }

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.destroyLiteSlider();
      this.pauseSideVideo();
      this.destroyVideoSwiper();
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.swiper = null;
      this.sliderMode = null;
    }

    isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    }

    syncSideVideoPlacement() {
      this.videoTrack = this.videoTrack || this.querySelector('.hero-banner__video-track');
      var wrapper = this.sliderEl && this.sliderEl.querySelector('.swiper-wrapper');
      if (!this.videoTrack || !wrapper) {
        return;
      }
      if (!this.videoItems.length) {
        this.videoItems = Array.from(this.videoTrack.querySelectorAll('.hero-banner__video-item'));
      }
      var placement = this.isMobile() ? 'mobile' : 'desktop';
      if (placement === this.videoPlacement) {
        return;
      }
      this.destroyVideoSwiper();
      this.pauseSideVideo();
      var destination = this.isMobile() ? wrapper : this.videoTrack.querySelector('.swiper-wrapper');
      this.videoItems.forEach(function(item) {
        item.classList.toggle('hero-banner__mobile-video-slide', placement === 'mobile');
        destination.appendChild(item);
      });
      this.videoPlacement = placement;
    }

    pauseSideVideo() {
      this.pauseInactiveVideo(null);
    }

    pauseInactiveVideo(activeSlide) {
      this.videoItems.forEach(function(item) {
        if (item === activeSlide) return;
        var video = item.querySelector('video');
        if (video) video.pause();
        var player = item.querySelector('.custom-video-wrapper');
        if (player) player.classList.remove('is-playing');
      });
      this.resumeVideoAutoplay();
    }

    stopVideoAutoplay() {
      [this.swiper, this.videoSwiper].forEach(function(slider) {
        if (slider && slider.autoplay) slider.autoplay.stop();
      });
    }

    resumeVideoAutoplay() {
      if (this.selectedVideoBlock || this.querySelector('[data-hero-video].is-playing')) return;
      [this.isMobile() ? null : this.swiper, this.videoSwiper].forEach(function(slider) {
        if (slider && !slider.destroyed && slider.autoplay && slider.params.autoplay.enabled && !slider.autoplay.running) {
          slider.autoplay.start();
        }
      });
    }

    destroyVideoSwiper() {
      if (this.videoSwiper && !this.videoSwiper.destroyed) this.videoSwiper.destroy(true, true);
      this.videoSwiper = null;
    }

    initVideoSwiper() {
      if (this.isMobile() || !this.videoTrack || this.videoSwiper || !window.Swiper) return;
      this.videoSwiper = new window.Swiper(this.videoTrack, {
        slidesPerView: 1,
        speed: toNumber(this.sliderEl.getAttribute('data-speed'), 4200),
        rewind: true,
        noSwipingSelector: '.custom-volume, .custom-video-play',
        navigation: { prevEl: this.querySelector('.js-video-prev'), nextEl: this.querySelector('.js-video-next') },
        autoplay: this.videoItems.length > 1 ? {
          delay: toNumber(this.sliderEl.getAttribute('data-delay-on-slide'), 4200),
          disableOnInteraction: false
        } : false,
        on: {
          slideChange: function(slider) {
            this.pauseInactiveVideo(slider.slides[slider.activeIndex]);
          }.bind(this)
        }
      });
      if (this.selectedVideoBlock || this.querySelector('[data-hero-video].is-playing')) this.stopVideoAutoplay();
    }

    onBlockSelect(event) {
      var item = this.videoItems.find(function(slide) { return slide.dataset.videoBlockId === event.detail.blockId; });
      if (!item) return;
      this.selectedVideoBlock = item;
      if (this.isMobile()) {
        if (this.swiper && this.swiper.params.loop) this.swiper.slideToLoop(Number(item.getAttribute('data-swiper-slide-index')), 0);
        else if (this.swiper) this.swiper.slideTo(Array.from(this.swiper.slides).indexOf(item), 0);
        else this.goToLiteSlide(this.slideEls.indexOf(item));
      } else if (this.videoSwiper) {
        this.videoSwiper.slideTo(this.videoItems.indexOf(item), 0);
      }
      this.stopVideoAutoplay();
    }

    onBlockDeselect() {
      this.selectedVideoBlock = null;
      this.resumeVideoAutoplay();
    }

    onResize() {
      if (!this.isConnected || !this.sliderEl) {
        return;
      }

      var nextMode = this.isMobile() ? 'mobile' : 'desktop';

      if (this.swiper && this.sliderMode && this.sliderMode !== nextMode) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        this.sliderMode = null;
        this.initSwiperWhenReady();
        return;
      }

      if (this.isMobile()) {
        if (!this.swiper && !this.liteSlider) {
          if (window.Swiper) {
            this.initSwiperWhenReady();
          } else {
            this.initLiteSlider();
          }
        }

        if (this.liteSlider) {
          this.updateLiteSlider();
        }

        return;
      }

      if (this.liteSlider) {
        this.destroyLiteSlider();
      }

      if (!this.swiper) {
        this.initSwiperWhenReady();
      }
    }

    initSwiperWhenReady(attempt) {
      attempt = attempt || 0;

      if (!this.isConnected || this.swiper || !this.sliderEl) {
        return;
      }

      window.clearTimeout(this.swiperWaitTimer);

      // Move the existing player before counting slides; desktop keeps its original layout.
      this.syncSideVideoPlacement();

      if (!window.Swiper) {
        if (this.isMobile()) {
          this.initLiteSlider();
        }

        if (attempt < 100) {
          this.swiperWaitTimer = window.setTimeout(this.initSwiperWhenReady.bind(this, attempt + 1), 50);
        }

        return;
      }

      var speed = toNumber(this.sliderEl.getAttribute('data-speed'), 4200);
      var delay = toNumber(this.sliderEl.getAttribute('data-delay-on-slide'), 4200);
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var initialSlide = this.liteSlider ? this.currentIndex : 0;
      this.destroyLiteSlider();
      var slideCount = this.sliderEl.querySelector('.swiper-wrapper').children.length;
      this.paginationEl = this.paginationEl || this.querySelector('.js-slider-pagination');
      var paginationEl = this.paginationEl;

      var swiperOptions = {
        slidesPerView: 1,
        speed: speed,
        loop: !isMobile || slideCount > 1,
        rewind: false,
        initialSlide: initialSlide,
        spaceBetween: 0
      };

      if (isMobile) {
        swiperOptions.slidesPerView = slideCount > 2 ? 1.08 : 1;
        swiperOptions.spaceBetween = 10;
        swiperOptions.noSwipingSelector = '.custom-volume, .custom-video-play';
        swiperOptions.on = {
          realIndexChange: function(swiper) {
            this.pauseInactiveVideo(swiper.slides[swiper.activeIndex]);
          }.bind(this)
        };

        if (paginationEl) {
          swiperOptions.pagination = {
            el: paginationEl,
            clickable: true
          };
        }
      } else {
        swiperOptions.navigation = {
          prevEl: this.querySelector('.js-slider-prev'),
          nextEl: this.querySelector('.js-slider-next')
        };

        swiperOptions.autoplay = {
          delay: delay,
          disableOnInteraction: false
        };
      }

      if (isMobile) {
        this.hydrateMobileSources();
      }

      this.swiper = new window.Swiper(this.sliderEl, swiperOptions);
      this.sliderMode = isMobile ? 'mobile' : 'desktop';
      this.initVideoSwiper();
    }

    initLiteSlider() {
      if (this.liteSlider || !this.sliderEl) {
        return;
      }

      this.syncSideVideoPlacement();
      this.wrapperEl = this.sliderEl.querySelector('.swiper-wrapper');
      this.slideEls = Array.from(this.sliderEl.querySelectorAll('.swiper-slide'));
      this.paginationEl = this.paginationEl || this.querySelector('.js-slider-pagination');

      if (!this.wrapperEl || this.slideEls.length <= 1) {
        return;
      }

      this.liteSlider = true;
      this.currentIndex = 0;
      this.wrapperEl.style.transition = 'transform 320ms ease';
      this.wrapperEl.style.willChange = 'transform';

      this.handlePrevClick = this.goToPrevLiteSlide.bind(this);
      this.handleNextClick = this.goToNextLiteSlide.bind(this);
      this.handlePaginationClick = this.onLitePaginationClick.bind(this);
      this.handleTouchStart = this.onLiteTouchStart.bind(this);
      this.handleTouchMove = this.onLiteTouchMove.bind(this);
      this.handleTouchEnd = this.onLiteTouchEnd.bind(this);

      var prevButton = this.querySelector('.js-slider-prev');
      var nextButton = this.querySelector('.js-slider-next');

      if (prevButton) {
        prevButton.addEventListener('click', this.handlePrevClick);
      }

      if (nextButton) {
        nextButton.addEventListener('click', this.handleNextClick);
      }

      this.sliderEl.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.sliderEl.addEventListener('touchmove', this.handleTouchMove, { passive: true });
      this.sliderEl.addEventListener('touchend', this.handleTouchEnd);
      this.buildLitePagination();
      this.hydrateMobileSources();
      this.loadLiteSlide(this.currentIndex);
      this.updateLiteSlider();
    }

    destroyLiteSlider() {
      if (!this.liteSlider) {
        return;
      }

      var prevButton = this.querySelector('.js-slider-prev');
      var nextButton = this.querySelector('.js-slider-next');

      if (prevButton && this.handlePrevClick) {
        prevButton.removeEventListener('click', this.handlePrevClick);
      }

      if (nextButton && this.handleNextClick) {
        nextButton.removeEventListener('click', this.handleNextClick);
      }

      if (this.sliderEl) {
        if (this.handleTouchStart) {
          this.sliderEl.removeEventListener('touchstart', this.handleTouchStart);
        }

        if (this.handleTouchMove) {
          this.sliderEl.removeEventListener('touchmove', this.handleTouchMove);
        }

        if (this.handleTouchEnd) {
          this.sliderEl.removeEventListener('touchend', this.handleTouchEnd);
        }
      }

      if (this.wrapperEl) {
        this.wrapperEl.style.transition = '';
        this.wrapperEl.style.transform = '';
        this.wrapperEl.style.willChange = '';
      }

      if (this.paginationEl) {
        this.paginationEl.innerHTML = '';
        this.paginationEl.classList.remove('swiper-pagination-bullets', 'swiper-pagination-horizontal');
      }

      this.liteSlider = false;
      this.wrapperEl = null;
      this.slideEls = [];
      this.handlePrevClick = null;
      this.handleNextClick = null;
      this.handlePaginationClick = null;
      this.handleTouchStart = null;
      this.handleTouchMove = null;
      this.handleTouchEnd = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
    }

    goToPrevLiteSlide() {
      this.goToLiteSlide(this.currentIndex - 1);
    }

    goToNextLiteSlide() {
      this.goToLiteSlide(this.currentIndex + 1);
    }

    goToLiteSlide(index) {
      if (!this.liteSlider || !this.wrapperEl || !this.slideEls.length) {
        return;
      }

      if (index < 0) {
        index = this.slideEls.length - 1;
      } else if (index >= this.slideEls.length) {
        index = 0;
      }

      this.currentIndex = index;
      this.pauseInactiveVideo(this.slideEls[index]);
      this.loadLiteSlide(index);
      this.updateLiteSlider();
    }

    buildLitePagination() {
      if (!this.paginationEl || !this.handlePaginationClick) {
        return;
      }

      this.paginationEl.innerHTML = '';
      this.paginationEl.classList.add('swiper-pagination-bullets', 'swiper-pagination-horizontal');

      for (var i = 0; i < this.slideEls.length; i += 1) {
        var bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        bullet.setAttribute('data-slide-index', i);
        bullet.addEventListener('click', this.handlePaginationClick);
        this.paginationEl.appendChild(bullet);
      }
    }

    onLitePaginationClick(event) {
      var target = event.currentTarget;
      var index = Number(target && target.getAttribute('data-slide-index'));

      if (Number.isFinite(index)) {
        this.goToLiteSlide(index);
      }
    }

    loadLiteSlide(index) {
      var slide = this.slideEls[index];

      this.hydrateSlideSources(slide);
    }

    hydrateSlideSources(slide) {
      if (!slide) {
        return;
      }

      var sources = slide.querySelectorAll('source[data-srcset]');

      for (var i = 0; i < sources.length; i += 1) {
        sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset'));
        sources[i].removeAttribute('data-srcset');
      }
    }

    hydrateMobileSources() {
      if (!this.sliderEl || !this.isMobile()) {
        return;
      }

      var sources = this.sliderEl.querySelectorAll('source[data-srcset]');

      for (var i = 0; i < sources.length; i += 1) {
        sources[i].setAttribute('srcset', sources[i].getAttribute('data-srcset'));
        sources[i].removeAttribute('data-srcset');
      }
    }

    updateLiteSlider() {
      if (!this.wrapperEl) {
        return;
      }

      var firstSlide = this.slideEls[0];
      var slideWidth = firstSlide ? firstSlide.getBoundingClientRect().width : this.sliderEl.getBoundingClientRect().width;
      var offset = this.currentIndex * (slideWidth + 10);

      this.wrapperEl.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      this.updateLitePagination();
    }

    updateLitePagination() {
      if (!this.paginationEl) {
        return;
      }

      var bullets = this.paginationEl.querySelectorAll('.swiper-pagination-bullet');

      for (var i = 0; i < bullets.length; i += 1) {
        var isActive = i === this.currentIndex;
        bullets[i].classList.toggle('swiper-pagination-bullet-active', isActive);
        bullets[i].setAttribute('aria-current', isActive ? 'true' : 'false');
      }
    }

    onLiteTouchStart(event) {
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this.ignoreTouch = Boolean(event.target.closest('.custom-volume, .custom-video-play'));

      if (this.ignoreTouch) {
        return;
      }

      if (!event.touches || !event.touches.length) {
        return;
      }

      this.touchStartX = event.touches[0].clientX;
      this.touchDeltaX = 0;
    }

    onLiteTouchMove(event) {
      if (this.ignoreTouch || !event.touches || !event.touches.length) {
        return;
      }

      this.touchDeltaX = event.touches[0].clientX - this.touchStartX;
    }

    onLiteTouchEnd() {
      if (Math.abs(this.touchDeltaX) < 40) {
        this.touchStartX = 0;
        this.touchDeltaX = 0;
        return;
      }

      if (this.touchDeltaX < 0) {
        this.goToNextLiteSlide();
      } else {
        this.goToPrevLiteSlide();
      }

      this.touchStartX = 0;
      this.touchDeltaX = 0;
    }
  });
})();
